import { BiPlacement, BiPlacementEdge } from '@euler/model/bi/dashboard';

/** A move from the card's ⋯ menu, where dragging is not offered. */
export enum BiCardMove {
  Up = 'up',
  Down = 'down',
  First = 'first',
  Last = 'last',
}

/** What the toast calls each move. */
export const kBiCardMoveTexts: Record<BiCardMove, string> = {
  [BiCardMove.Up]: '已上移',
  [BiCardMove.Down]: '已下移',
  [BiCardMove.First]: '已移到最前',
  [BiCardMove.Last]: '已移到最后',
};

/**
 * Where a move puts the card, against its neighbours in reading order:
 * before the one above, after the one below, or at an edge. Null when the
 * card is already there (or not in the order).
 */
export function biCardMovePlacement(
  order: string[],
  cardId: string,
  move: BiCardMove,
): BiPlacement | null {
  const index = order.indexOf(cardId);
  if (index < 0) return null;
  const first = index === 0;
  const last = index === order.length - 1;
  switch (move) {
    case BiCardMove.Up:
      return first ? null : { anchor: { before: order[index - 1] } };
    case BiCardMove.Down:
      return last ? null : { anchor: { after: order[index + 1] } };
    case BiCardMove.First:
      return first ? null : { anchor: BiPlacementEdge.Top };
    case BiCardMove.Last:
      return last ? null : { anchor: BiPlacementEdge.Bottom };
  }
}
